<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? "Edit" : "New"} Region` }}
            </h4>
            <v-form ref="regionForm" @submit.prevent="save()">
              <v-row>
                <v-col md="12">
                  <v-text-field
                    v-model="regionModel.name"
                    label="Region Name"
                    required
                    outlined
                    :rules="[(v) => !!v || 'Region Name is required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { Region } from "@/models/Region";
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      regionModel: new Region(),
      me: "",
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: "Regions",
          disabled: false,
          href: "/admin/regions",
        },
        {
          text: "Region Detail",
          disabled: false,
          href: `/admin/region/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} Region`,
          disabled: true,
        },
      ];
    },
  },
  watch: {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    region: {
      query: gql`
        query Region($id: ID!) {
          region(id: $id) {
            id
            name
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.regionModel.id = this.region.id;
        this.regionModel.name = this.region.name;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.regionForm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        // update
        await this.updateRegion()
          .then(() => {
            this.$swal("Success!", "Region was updated", "success");
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              "something went wrong when trying to update the region, check data and try again later!",
              "error"
            );
          });
      } else {
        // create
        await this.createRegion()
          .then(() => {
            this.$swal("Success!", "Region was created", "success");
            window.location.href = `/admin/region/${self.regionModel.id}/edit`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              `Something went wrong when creating the region, check data and try again later!`,
              "error"
            );
          });
      }
      this.isLoading = false;
    },
    async updateRegion() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($region: RegionUpdateInput!) {
              updateRegion(region: $region) {
                id
                updated
              }
            }
          `,
          variables: {
            region: {
              id: self.regionModel.id,
              name: self.regionModel.name,
              createdBy: self.me.id,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the region!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createRegion() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createRegion($region: RegionCreateInput!) {
              createRegion(region: $region) {
                id
              }
            }
          `,
          variables: {
            region: {
              name: self.regionModel.name,
              createdBy: self.me.id,
            },
          },
        });

        if (!response) {
          throw "Something went wrong when creating the Region Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createRegion) {
          self.regionModel.id = response?.data?.createRegion?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
